import { useState } from "react";
import React from "react";
import { SvgArrowRight, SvgLogo } from "ui/svgs";
import { CameraInfo } from "lib/types";
import { showToast } from "ui/components/common";
import usePresetRtcService from "ui/preset/service";
import clsx from "clsx";
import { useCommonService } from "pages/service";
export default function CameraWithPresetItem({
  camera,
  cameraSelected,
  onPresetClick,
  currentPreset,
}: {
  camera: CameraInfo;
  cameraSelected: boolean;
  onPresetClick: (preset: any) => void;
  currentPreset: any;
}) {
  const { getPresetSnapShotWithDbCache, getPresetList } = usePresetRtcService();
  const { takeSnapshot } = useCommonService();
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");

  const refContent = React.useRef<HTMLDivElement>(null);

  const [presets, setPresets] = useState([]);
  const [loadingPreset, setLoadingPreset] = useState(false);

  function toggleAccordion(active: boolean) {
    setActive(active);
    if (refContent.current != null && refContent.current != undefined) {
      setHeight(!active ? "0px" : `${refContent.current.scrollHeight}px`);
    }
  }
  const rotate = active ? "rotate(90deg)" : "rotate(0)";

  function refreshPresetList() {
    setLoadingPreset(true);
    if (camera?.capabilities?.ptz === false) {
      setPresets([
        {
          id: 1,
          modifiedAt: 0,
          name: "Static Preset",
          algorithm: [],
          snapshot: null,
        },
      ]);
      setTimeout(() => toggleAccordion(true), 200);
      return takeSnapshot([camera], camera.orgId + "", (snapShots) => {
        setLoadingPreset(false);
        setPresets([
          {
            id: 1,
            modifiedAt: 0,
            name: "Static Preset",
            algorithm: [],
            snapshot: URL.createObjectURL(snapShots[0].blob),
          },
        ]);
      });
    }

    return getPresetList(+camera.orgId, +camera.nvrId, camera?.devId, camera)
      .then((res) => {
        console.log("presetList res", res);
        const _presetList = res.presetList.map((item) => ({
          id: item.id,
          modifiedAt: item.modifiedAt,
          name: item.name,
          algorithm: [],
          snapshot: null,
        }));
        setLoadingPreset(false);
        setPresets([..._presetList]);
        setTimeout(() => toggleAccordion(true), 200);
        _presetList.forEach((preset) => {
          getPresetSnapShotWithDbCache(
            +camera.orgId,
            +camera.nvrId,
            camera.devId,
            camera,
            preset.id,
            preset.modifiedAt.toString(),
          ).then(async (blob) => {
            preset.snapshot = URL.createObjectURL(blob);
            setPresets([..._presetList]);
          });
        });
      })
      .catch((err) => {
        console.error(err);
        setLoadingPreset(false);
        setPresets([]);

        showToast(1, "Failed to fetch preset list");
      });
  }

  async function handleClickCamera() {
    if (active) {
      toggleAccordion(false);
    } else {
      refreshPresetList();
    }
  }

  return (
    <>
      <div className="flex items-center justify-between group/site-item">
        <button
          id="btnSite"
          className="flex items-center p-3 w-full"
          onClick={handleClickCamera}
        >
          <SvgArrowRight
            width="22"
            style={{ transform: rotate, transition: "all 0.2s linear" }}
            className="fill-neutral-500 mr-1 flex-shrink-0"
          />
          <span className="text-left">{camera?.name}</span>
          <div className=" ml-auto">
            {loadingPreset && (
              <div
                className="text-blue-500 inline-block h-4 w-4 ml-2 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              ></div>
            )}
          </div>
        </button>
      </div>
      <div
        ref={refContent}
        className="overflow-hidden"
        style={{ maxHeight: `${height}`, transition: "max-height 0.4s ease" }}
      >
        {!loadingPreset && presets.length == 0 && (
          <div className="text-sm text-center text-neutral-400">No Preset</div>
        )}
        <div className="grid grid-cols-2 gap-2 w-full max-w-5xl mx-auto ">
          {presets?.map((preset, index) => {
            let homePreset = false;
            if (index === 0) {
              homePreset = true;
            }
            const selected = cameraSelected && currentPreset?.id === preset?.id;
            return (
              <div
                className={"relative h-full cursor-pointer"}
                onClick={() => onPresetClick(preset)}
                key={preset?.id}
              >
                {preset.snapshot ? (
                  <img
                    src={preset.snapshot}
                    className={clsx(
                      "aspect-video h-full min-w-[160px] rounded-lg",
                      {
                        "opacity-40": selected,
                      },
                    )}
                  ></img>
                ) : (
                  <div
                    className={clsx(
                      "aspect-video bg-zinc-100 h-full rounded-lg flex flex-col items-center justify-center",
                      selected
                        ? "border-4 border-[#3E83F6]"
                        : "border-4 border-transparent",
                    )}
                  >
                    <SvgLogo width="24" className="fill-neutral-400 mb-3 w-8" />
                  </div>
                )}
                <div
                  style={{
                    cursor: "default",
                    position: "absolute",
                    bottom: "6px",
                    left: "6px",
                    textAlign: "center",
                    borderRadius: "4px",
                    height: "25px",
                    padding: "0px 4px",
                    backgroundColor: homePreset
                      ? "rgba(220, 231, 253, 1)"
                      : "rgba(34, 34, 34, 0.72)",
                    color: homePreset ? "rgba(62, 131, 246, 1)" : "white",
                  }}
                >
                  {homePreset ? "Home Preset" : preset.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
